import Image from "./Image";
import Video from "./Video";
import DocumentCustom from "./DocumentCustom";
import Audio from "./Audio";
import AudioTemp from "./AudioTemp";
import Contact from "./Contact";
import MultiChoice from "./MultiChoice";
import Location from "./Location";
import CardMsg from "./CardMsg";
import CarouselMsg from "./CarouselMsg";

export {
    Image,
    Video,
    Audio,
    DocumentCustom,
    AudioTemp,
    Contact,
    MultiChoice,
    Location,
    CardMsg,
    CarouselMsg
}



// WEBPACK FOOTER //
// src/modules/screens/chatscreen/components/AssistComponents/index.js